import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FilterList, CloudDownload } from "@material-ui/icons/";
import {
  Typography,
  Grid,
  Box,
  Popper,
  Popover,
  Paper,
  CircularProgress,
  ClickAwayListener,
} from "@material-ui/core";
import View from "components/utils/View";
import { useStyles } from "./transactionsStyles";
import useTransactions from "./useTransactions";
import Filters from "./Filters";
import {
  DateRange,
  SrButton,
  SrFilterButton,
  SrContentWrapper,
  SrContentHeader,
} from "../../../common";
import translate from "../../../../i18n/translate";
import { TransactionsTable } from "../../../TransactionsTable";

const Transactions = () => {
  const classes = useStyles();
  const { user } = useSelector(({ auth }) => auth);
  const [range, setRange] = useState(); // maybe move to useTransactions
  const [filterButton, setFilterButton] = useState();
  const [exportButton, setExportButton] = useState();

  const {
    loading,
    transactions,
    paginationConfig,
    getTransactionsData,
    filters,
  } = useTransactions(range, user.username);

  const handleExportClick = (event) => {
    filters.onExportClick();
    setExportButton(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportButton(null);
  };

  const handleFilterClick = (event) => {
    filters.onFiltersOpen();
    setFilterButton(event.currentTarget);
  };

  const handleFilterClose = (evt) => {
    if (!evt.target.classList.contains("filter-item")) {
      setFilterButton(null);
    }
  };

  const onApplyFilters = () => {
    setFilterButton(null);
    filters.onApplyFilters();
  };

  const onCleanFilters = () => {
    setFilterButton(null);
    filters.onCleanFilters();
  };

  return (
    <View translateTitleKey="menu.transactions">
      <Grid container direction="column" spacing={2}>
        <SrContentHeader
          title={translate("menu.transactions")}
          actions={
            <>
              <SrFilterButton
                className={classes.button}
                endIcon={<CloudDownload />}
                onClick={handleExportClick}
              >
                {translate("transactions.export")}
              </SrFilterButton>
              <Popover
                anchorEl={exportButton}
                open={!!exportButton}
                onClose={handleExportClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <Box display="flex" margin={2}>
                  {filters.downloadUrl ? (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <Typography>
                        {translate("transactions.yourReportHasBeenCreated")}
                      </Typography>
                      <Box margin={1}>
                        <SrButton
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            window.open(filters.downloadUrl, "_blank");
                            handleExportClose();
                            filters.onDownloadClick();
                          }}
                        >
                          {translate("transactions.download")}
                        </SrButton>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <Typography>
                        {translate("transactions.creatingReport")}
                      </Typography>
                      <Box marginLeft={1}>
                        <CircularProgress />
                      </Box>
                    </Box>
                  )}
                </Box>
              </Popover>
              <SrFilterButton
                className={classes.button}
                endIcon={<FilterList />}
                onClick={handleFilterClick}
              >
                {translate("transactions.filter")}
              </SrFilterButton>
              <Popper
                anchorEl={filterButton}
                open={!!filterButton}
                onClose={handleFilterClose}
              >
                <ClickAwayListener
                  mouseEvent="onMouseDown"
                  onClickAway={handleFilterClose}
                >
                  <Filters
                    selectedChargeMethods={filters.selectedChargeMethods}
                    onCheckboxChange={filters.onCheckboxChange}
                    operators={filters.operators}
                    selectedOperator={filters.selectedOperator}
                    onOperatorChange={filters.onOperatorChange}
                    onApplyFilters={onApplyFilters}
                    onCleanFilters={onCleanFilters}
                    selectedCard={filters.selectedCard}
                    onCardClick={filters.onCardClick}
                  />
                </ClickAwayListener>
              </Popper>

              <DateRange
                onDateSelected={({ startDate, endDate }) => {
                  setRange({ startDate, endDate });
                }}
                actionButtons
              />
            </>
          }
        />
        <Grid item xs={12}>
          <SrContentWrapper
            isLoading={loading}
            isEmpty={!transactions?.rows?.length}
            emptyMessage={translate("transactions.noData")}
          >
            <Paper elevation={0}>
              <Box padding={2} paddingLeft="0px" paddingRight="0px">
                <TransactionsTable
                  updateTransactions={getTransactionsData}
                  transactions={transactions}
                  paginationConfig={paginationConfig}
                  loading={loading}
                />
              </Box>
            </Paper>
          </SrContentWrapper>
        </Grid>
      </Grid>
    </View>
  );
};

export default Transactions;
